// evaluate other hashing libraries
import sha256 from "hash.js/lib/hash/sha/256";

const cacheHeuristicPeriod = 5;

const opCanvas = document.createElement("canvas");
const opContext = opCanvas.getContext("2d");

export const draw = ({ documentCanvas, operations, /*thumbnailsByOperation,*/ cache, hashInDocumentByOperation }) => {
	const documentContext = documentCanvas.getContext("2d");

	documentContext.clearRect(0, 0, opCanvas.width, opCanvas.height);

	opCanvas.width = documentCanvas.width;
	opCanvas.height = documentCanvas.height;

	let lastCachedOpIndex = -Infinity; //  maybe should be -1
	let operationIndex = operations.length - 1;
	for (; operationIndex >= 0; operationIndex--) {
		const operation = operations[operationIndex];
		const operationHash = hashInDocumentByOperation.get(operation);
		if (cache[`document-at-${operationHash}`]) {
			documentContext.drawImage(cache[`document-at-${operationHash}`], 0, 0);
			lastCachedOpIndex = operationIndex;
			break;
		}
	}
	if (operationIndex > -1) {
		// console.log("Starting from checkpoint:", operationIndex);
	} else {
		// console.log("Starting with empty cache");
	}
	operationIndex++;
	const runningHash = sha256();
	for (; operationIndex < operations.length; operationIndex++) {
		const operation = operations[operationIndex];
		runningHash.update(JSON.stringify(operation));
		const operationHash = runningHash.digest("hex");
		opContext.clearRect(0, 0, opCanvas.width, opCanvas.height);
		if (cache[`individual-${operationHash}`]) {
			// console.log("cache hit");
			documentContext.drawImage(cache[`individual-${operationHash}`], 0, 0);
			lastCachedOpIndex = operationIndex;
		} else {

			const { points, tool, swatch } = operation;

			tool.drawFromPoints(opContext, points, swatch, documentContext);

			documentContext.drawImage(opCanvas, 0, 0);

			hashInDocumentByOperation.set(operation, operationHash);

			// fill the cache
			if (!operation.updatingContinuously) {
				if (operationIndex >= lastCachedOpIndex + cacheHeuristicPeriod) {
					cache[`document-at-${operationHash}`] = document.createElement("canvas");
					cache[`document-at-${operationHash}`].width = opCanvas.width;
					cache[`document-at-${operationHash}`].height = opCanvas.height;
					cache[`document-at-${operationHash}`].getContext("2d").drawImage(documentCanvas, 0, 0);
					lastCachedOpIndex = operationIndex;
				}
			}
		}
	}
};

